import { removeCartItem, handleQuantityClick } from '../utils/cart-tools';

const headerCartEl = document.querySelector('.link-group.cart-nav');
const addRemoveImage = (e) => {
  const {currentTarget, type} = e;
  const imageEl = document.querySelector('.shop-image');

  if (type == 'mouseenter') {
    imageEl.src = currentTarget.dataset.collectionImage;
  } else if (type == 'mouseleave') {
    imageEl.src = imageEl.dataset.src;
  }
};

document.addEventListener('DOMContentLoaded', () => {
  const linkGroups = document.querySelectorAll('.link-group.top-level-link');
  const drawers = document.querySelectorAll('.mobile-nav__drawer');

  linkGroups.forEach((el) => {
    el.addEventListener('click', (e) => {
      const {currentTarget, target} = e;

      if (!currentTarget.classList.contains('open')) {
        if (document.querySelector('.link-group.top-level-link.open')) {
          document
            .querySelector('.link-group.top-level-link.open')
            .classList.remove('open');
        }
        currentTarget.classList.add('open');
        const searchInputEl = currentTarget.querySelector('.search__input');
        if (searchInputEl) {
          searchInputEl.focus();
        }
      }

      if (target.classList.contains('menu-button-close')) {
        currentTarget.classList.remove('open');

        const searchInputEl = currentTarget.querySelector('.search__input');

        if (searchInputEl) {
          searchInputEl.blur();
        }
      }
    });
  });

  // Opens drawers on mobile nav menu
  drawers.forEach((el) => {
    el.addEventListener('click', (e) => {
      if (!el.classList.contains('open')) {
        const {currentTarget} = e;

        if (document.querySelector('.mobile-nav__drawer.open')) {
          document
            .querySelector('.mobile-nav__drawer.open')
            .classList.remove('open');
        }

        currentTarget.classList.add('open');
      } else {
        el.classList.remove('open');
      }
    });
  });

  //Handles Cart Functions
  if(headerCartEl) {
    headerCartEl.addEventListener('click', (e) => {
      const { target } = e;

      handleQuantityClick({ target });
      removeCartItem({ target });

      /* Wholesale: Reroutes Place Order Button Click to Login page if not logged in */
      if (
        target.classList.contains('full-cart__button')
        && (window.theme.isWholesale && !window.theme.customer.isLoggedIn)
      ) {
        e.preventDefault();
        window.location = '/account/login';
      }
    });
  }

  // Adds images on hover
  document
    .querySelectorAll('.link-links__more.more-shop a[data-collection-image]')
    .forEach((el) => {
      el.addEventListener('mouseenter', addRemoveImage);
      el.addEventListener('mouseleave', addRemoveImage);
    });

  // Focus Search in header on hover
  document
  .querySelector('.desktop-nav .link-group--for-search')
  .addEventListener('mouseenter', ({ target }) => {
    const search = target.querySelector('.search__input');
    search.focus();
  });

  document.querySelectorAll('.desktop-nav .link-group').forEach(linkGroupEl => {
    var mouseEnterTimeout = () => {};
    var mouseOutTimeout = () => {};

    linkGroupEl.addEventListener('mouseenter', event => {
      const { target } = event;
      clearTimeout(mouseOutTimeout);
      mouseEnterTimeout = setTimeout(() => {
        target.classList.add('hover');
      }, 250);
    });

    linkGroupEl.addEventListener('mouseleave', event => {
      const { target } = event;
      clearTimeout(mouseEnterTimeout);
      mouseOutTimeout = setTimeout(() => {
        target.classList.remove('hover');
      }, 250);
    });

  });
});
